import axios from "@/axiosConfig";

export default ({
  state: {
    exams: [],
    nextPage: 0,
  },
  actions: {
    getMyExamsApi({ commit }) {
      axios.get('lectures/my/exams')
        .then(response => {
          commit('SET_EXAMS', response);
        })
        .catch(error => {
          console.log(error)
        })
    },
    getNextMyExamsApi({ commit, state }) {
      axios.get('lectures/my/exams?page=' + state.nextPage)

        .then(response => {
          commit('SET_NEXT_EXAMS', response);
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
  mutations: {
    SET_EXAMS(state, response) {
      console.log(response.data.pagination);
      state.exams = response.data.data;
      state.nextPage = ((response.data.pagination.current_page + 1) <= response.data.pagination.last_page) ? response.data.pagination.current_page + 1 : 0;
    },
    SET_NEXT_EXAMS(state, response) {
      (response.data.data).forEach(element => {
        state.exams.push(element);
      });
      console.log(response.data.pagination);
      state.nextPage = ((response.data.pagination.current_page + 1) <= response.data.pagination.last_page) ? response.data.pagination.current_page + 1 : 0;
    }
  },
  getters: {
    exams: state => state.exams,
    nextPage: state => state.nextPage,
  },
  namespaced: true,
});
